import { ComponentProps, useState } from 'react';
import ColumnFiltersMenu from './ColumnFiltersMenu';
import { ColumnActions, SortButtons } from './TableShared';
import type { Column } from './types';

type Props<T> = Pick<
  ComponentProps<typeof SortButtons>,
  'sortBy' | 'sortDirection' | 'onSort'
> &
  Pick<
    ComponentProps<typeof ColumnFiltersMenu>,
    | 'getFilterOptions'
    | 'selectedFilters'
    | 'addFilter'
    | 'updateFilter'
    | 'isLoading'
  > & {
    column: Column<T>;
  };

const ColumnHeaderActions = <T,>({
  column,
  sortBy,
  sortDirection,
  onSort,
  getFilterOptions,
  selectedFilters,
  addFilter,
  updateFilter,
  isLoading,
}: Props<T>) => {
  const [isFilterMenuOpen, setIsFilterMenuOpen] = useState(false);

  return (
    <ColumnActions
      aria-label={`column-actions-${column.id}`}
      $isActive={
        sortBy === column.id ||
        isFilterMenuOpen ||
        selectedFilters?.some((f) => f.property === column.id)
      }
    >
      {(column.sortable || column.sortable === undefined) && (
        <SortButtons
          columnId={column.id}
          sortBy={sortBy}
          sortDirection={sortDirection}
          onSort={onSort}
        />
      )}
      {(column.filterable || column.filterable === undefined) &&
        !column.hideColumnFilter && (
          <ColumnFiltersMenu
            columnId={column.id}
            isCounterHidden={column.isFilterCounterHidden}
            getFilterOptions={getFilterOptions}
            selectedFilters={selectedFilters}
            addFilter={addFilter}
            updateFilter={updateFilter}
            renderer={column.filterRenderer}
            emptyValueLabel={column.emptyValueLabel}
            showSelectAll={column.showSelectAll}
            type={column.type}
            sortOptions={column.sortFilterOptions !== false}
            width={column.filterDropdownWidth}
            isLoading={isLoading}
            onOpenChange={setIsFilterMenuOpen}
          />
        )}
    </ColumnActions>
  );
};

export default ColumnHeaderActions;
